import { createClient } from '@sanity/client';

export const client = createClient({
  projectId: '6xn0golz',
  dataset: 'production',
  apiVersion: '2025-01-01',
  useCdn: false
});